export default "__VITE_ASSET__D1Nu2i0O__"